export default function filterRowByStatus(values, rowData) {
  if (values.length) {
    const parsedValues = values?.map((value) => value?.toLowerCase());
    return parsedValues.includes(rowData?.status?.toLowerCase());
  } else {
    return true;
  }
}
